import React from 'react';
import { Loading } from '@goodfynd/ui';
import { useRouter } from 'next/router';

type LayoutEmbedProps = {
  children: React.ReactNode;
};

export function LayoutEmbed({ children }: LayoutEmbedProps): JSX.Element {
  const { isReady } = useRouter();

  if (!isReady) {
    return <Loading type="line" />;
  }

  return <>{children}</>;
}
